type State = Record<string, any>;

export default function experiments(state: State = {}): State {
  return state;
}
